// removed by extract-text-webpack-plugin
module.exports = {"oddsButton":"_3xwm95imwp2KetZzQBvMsv","checked":"_3RoMCLN384iSfq4NbnuLK_","disabled":"_1MVaVlgWac7uDAzpUuqnQJ","selected":"_2lJfmvUNPa4QQF2QEx6iAJ","oddsButtonCustom":"_1-DBBWOdn-lQqgM1QuEzE"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/matchday/css/oddsButton.css
// module id = 844
// module chunks = 0